import { useTranslation } from "react-i18next";
import { stockLevel } from "@/lib/product";

const STYLES = {
  in: "bg-[hsl(var(--success))]/10 text-[hsl(var(--success))] border-[hsl(var(--success))]/25",
  limited:
    "bg-[hsl(var(--warning))]/10 text-[hsl(var(--warning))] border-[hsl(var(--warning))]/25",
  supplier:
    "bg-[hsl(var(--warning))]/10 text-[hsl(var(--warning))] border-[hsl(var(--warning))]/25",
  out: "bg-[hsl(var(--danger))]/10 text-[hsl(var(--danger))] border-[hsl(var(--danger))]/25",
  unavailable: "bg-secondary text-muted-foreground border-border",
};

const LABELS = {
  in: "stock.in",
  limited: "stock.limited",
  supplier: "stock.supplier",
  out: "stock.out",
  unavailable: "stock.unavailable",
};

/** Green / orange / red stock indicator, always with a text label (a11y). */
export const StockBadge = ({ product, className = "" }) => {
  const { t } = useTranslation();
  const level = stockLevel(product);

  return (
    <span
      className={`inline-flex items-center gap-1.5 whitespace-normal rounded-full border px-2 py-0.5 text-xs font-medium ${STYLES[level]} ${className}`}
      data-testid="stock-badge"
      data-stock-level={level}
    >
      <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-current" aria-hidden="true" />
      {t(LABELS[level])}
    </span>
  );
};
